var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.54 5.54a.65.65 0 0 1 .92 0l6 6a.65.65 0 0 1 0 .92l-6 6a.65.65 0 1 1-.92-.92L14.08 12 8.54 6.46a.65.65 0 0 1 0-.92Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik04LjU0MDM5IDUuNTQwMzhDOC43OTQyMyA1LjI4NjU0IDkuMjA1NzggNS4yODY1NCA5LjQ1OTYzIDUuNTQwMzhMMTUuNDU5NiAxMS41NDA0QzE1LjcxMzUgMTEuNzk0MiAxNS43MTM1IDEyLjIwNTggMTUuNDU5NiAxMi40NTk2TDkuNDU5NjMgMTguNDU5NkM5LjIwNTc4IDE4LjcxMzUgOC43OTQyMyAxOC43MTM1IDguNTQwMzkgMTguNDU5NkM4LjI4NjU1IDE4LjIwNTggOC4yODY1NSAxNy43OTQyIDguNTQwMzkgMTcuNTQwNEwxNC4wODA4IDEyTDguNTQwMzkgNi40NTk2MkM4LjI4NjU1IDYuMjA1NzggOC4yODY1NSA1Ljc5NDIyIDguNTQwMzkgNS41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";